import { makeClosedTask, makeOptions, normalizeMay2026Variant, pick } from "../../../../matura/MaturaMay2026ClosedTaskSupport";

export function task06(variant) {
  const original = {
    c: 5, r: 2, expression: "x^{2}+10x+25", xLatex: "\\sqrt{2}-5", result: "2",
    options: [["A", "2"], ["B", "\\sqrt{2}"], ["C", "2-20\\sqrt{2}"], ["D", "62-10\\sqrt{2}"]],
  };
  const pool = [
    { c: 2, r: 3 }, { c: 2, r: 5 }, { c: 3, r: 2 }, { c: 3, r: 5 },
    { c: 4, r: 2 }, { c: 4, r: 3 }, { c: 5, r: 3 }, { c: 5, r: 7 },
    { c: 6, r: 2 }, { c: 6, r: 5 }, { c: 7, r: 2 }, { c: 7, r: 3 },
  ];
  const chosen = variant === "original" ? original : pick(pool);
  const item = chosen.expression ? chosen : {
    ...chosen,
    expression: "x^{2}+" + (2 * chosen.c) + "x+" + (chosen.c * chosen.c),
    xLatex: "\\sqrt{" + chosen.r + "}-" + chosen.c,
    result: String(chosen.r),
  };
  const wrong = [
    "\\sqrt{" + item.r + "}",
    String(item.r + item.c * item.c),
    item.r + "-" + (2 * item.c) + "\\sqrt{" + item.r + "}",
  ];
  const { options, correctIndex } = makeOptions(item.result, wrong, item.options);
  return makeClosedTask({
    type: "MaturaBinomialRootValueClosedTask",
    taskNumber: "6",
    variant,
    tags: ["wzory skroconego mnozenia", "pierwiastki"],
    data: {
      instruction: "Dokończ zdanie. Wybierz właściwą odpowiedź spośród podanych.",
      prompt: "Wartość wyrażenia dla podanej wartości zmiennej jest równa:",
      latex: item.expression + ",\\quad x=" + item.xLatex,
      options,
      correctIndex,
      explanationTitles: ["Rozpoznajemy wzór skróconego mnożenia.", "Podstawiamy podaną wartość zmiennej.", "Obliczamy kwadrat pierwiastka."],
      explanationLines: [
        item.expression + "=(x+" + item.c + ")^2",
        "x=" + item.xLatex + "\\quad\\Rightarrow\\quad x+" + item.c + "=\\sqrt{" + item.r + "}",
        "(\\sqrt{" + item.r + "})^2=" + item.r,
      ],
      alternativeExplanation: {
        title: "Inny sposób: bezpośrednie podstawienie",
        intro: "Możemy najpierw podstawić podaną wartość zmiennej, a następnie wykonać wszystkie działania.",
        steps: [
          {
            title: "Podstawiamy wartość zmiennej do wyrażenia.",
            latex: item.expression + "\\bigg|_{x=" + item.xLatex + "}=\\left(" + item.xLatex + "\\right)^2+" + (2 * item.c) + "\\left(" + item.xLatex + "\\right)+" + (item.c * item.c),
          },
          {
            title: "Rozwijamy kwadrat różnicy i redukujemy wyrazy podobne.",
            latex: "\\begin{aligned}&\\left(" + item.xLatex + "\\right)^2+" + (2 * item.c) + "\\left(" + item.xLatex + "\\right)+" + (item.c * item.c) + "=\\\\&=" + item.r + "-" + (2 * item.c) + "\\sqrt{" + item.r + "}+" + (item.c * item.c) + "+" + (2 * item.c) + "\\sqrt{" + item.r + "}-" + (2 * item.c * item.c) + "+" + (item.c * item.c) + "=\\\\&=" + item.r + ".\\end{aligned}",
          },
        ],
        note: "Otrzymujemy ten sam wynik. Ten sposób jest poprawny, ale wymaga więcej rachunków niż rozpoznanie wzoru skróconego mnożenia.",
      },
    },
  });
}

export function generateTask(options = {}) {
  return task06(normalizeMay2026Variant(options));
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
